export default {
  EXPENSES_TABLE_STATE_SET: 'EXPENSES/TABLE_STATE_SET',
  EXPENSES_TABLE_STATE_RESET: 'EXPENSES/TABLE_STATE_RESET',
};
